import { Badge } from "../components/ui/badge";
import { Clock, Loader2, CheckCircle2 } from "lucide-react";

export const StatusBadge = ({ status }) => {
  const config = {
    pending: {
      label: "Pending",
      icon: Clock,
      className: "bg-amber-100 text-amber-800 hover:bg-amber-100 border-amber-200",
    },
    analyzing: {
      label: "Analyzing…",
      icon: Loader2,
      className: "bg-blue-100 text-blue-800 hover:bg-blue-100 border-blue-200",
    },
    completed: {
      label: "Analysis Ready",
      icon: CheckCircle2,
      className: "bg-emerald-100 text-emerald-800 hover:bg-emerald-100 border-emerald-200",
    },
  };
  const cfg = config[status] || config.pending;
  const Icon = cfg.icon;
  return (
    <Badge
      data-testid={`status-badge-${status}`}
      variant="outline"
      className={`rounded-full px-2.5 py-1 text-xs font-semibold flex items-center gap-1.5 ${cfg.className}`}
    >
      <Icon className={`w-3 h-3 ${status === "analyzing" ? "animate-spin" : ""}`} />
      {cfg.label}
    </Badge>
  );
};
